import { render, staticRenderFns } from "./priceDetails.vue?vue&type=template&id=2350cb7e&scoped=true"
import script from "./priceDetails.vue?vue&type=script&lang=js"
export * from "./priceDetails.vue?vue&type=script&lang=js"
import style0 from "./priceDetails.vue?vue&type=style&index=0&id=2350cb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2350cb7e",
  null
  
)

export default component.exports